import React, { useState, useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import backIcon from '../../assest/images/11.png';
import DatePicker from 'react-datepicker'; // Import the DatePicker component
import 'react-datepicker/dist/react-datepicker.css'; // Import the DatePicker styles
import calendarIcon from '../../assest/images/10.jpg'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Icon7 from '../../assest/images/Icon7.png'
import Icon3 from "../../assest/images/Icon3.png";
import Icon5 from "../../assest/images/Icon5.png";
import accept from "../../assest/images/accept.png";
import Select from 'react-select';
import { UserContext } from '../common/UserContext';
import config from '../../envconfig';
// import { IoCaretDownOutline } from 'react-icons/io5';
import { IoCaretUpOutline, IoCaretDownOutline, IoCalendarOutline } from 'react-icons/io5';
import { Check } from "lucide-react";
import x from '../../assest/images/x.png';
import Image from '../common/image';
import CustomDropdown from '../common/CustomDropdown';
import ReactDOM from "react-dom/client";
import ReactSelectDropDown from '../common/ReactSelectDropDown';

const EditOrderList = () => {
  const [orderTableData, setOrderTableData] = useState([]);
  const [error, setError] = useState(null);
  const [errormsgOrderQuantity, seterrormsgOrderQuantity] = useState('');
  const [isQuantityvalid, setisQuantityvalid] = useState(false);
  const [oldtabledata, setoldtabledata] = useState()
  const [selectedProductName, setSelectedProductName] = useState('');
  const [productcode, setproductcode] = useState('');
  const [availableQuantity, setavailableQuantity] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [scpName, setScpName] = useState('');
  const [orderQuantity, setOrderQuantity] = useState('');
  // const [, setOrderNumber] = useState(''); // Define orderNumber state variable
  const { ORDM_OrderID, ORDM_OrderNumber } = useParams();
  const [productNames, setProductNames] = useState([]);
  const [dropdownKeyprdname, setDropdownKeyprdname] = useState(0);
  const [fetchedData, setFetchedData] = useState(null);
  const [orderNumber,] = useState('***');
  const [orderDate, setOrderDate] = useState(new Date()); // State for order date
  const [isTemplatePopupOpen, setIsTemplatePopupOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const { UM_GroupId, UM_CompanyGrpID, UM_UserCode, UM_CompanyID, UM_UserId, selectedScpId } = useParams();
  // const { UM_GroupId, UM_CompanyID, UM_CompanyGrpID, UM_UserId, UM_UserCode, selectedScpId } = useParams();
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [productid, setProductid] = useState(null);
  const [selectedfromScpName, setSelectedfromScpName] = useState('');
  const [selectedfromScpID, setselectedfromScpID] = useState('');
  const [selectedTOSCPID, setselectedTOSCPID] = useState('');
  const [selectedfromScpLevelNo, setselectedfromScpLevelNo] = useState('');
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [tempOrderQuantity, setTempOrderQuantity] = useState('');
  const [orderData, setOrderData] = useState([]);
  const [firstToScpName, setFirstToScpName] = useState('');
  const inputRef = useRef(null);
  const [orderID, setorderID] = useState('');
  const navigate = useNavigate();
  const [editedProductName, setEditedProductName] = useState('');
  const [filteredProductNames, setFilteredProductNames] = useState([]);
  const [totalPackSize, setTotalPackSize] = useState('');
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [orderTypes, setorderTypes] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState('');
  const [oId, setoId] = useState();
  const [issavedisabled, setIsSaveDisabled] = useState(false);
  const [addedProducts, setAddedProducts] = useState([]);
  const [removedProducts, setRemovedProducts] = useState([]);
  const [quantityChangedProducts, setQuantityChangedProducts] = useState([]);

  const [isSchemeModalOpen, setIsSchemeModalOpen] = useState(false);
  const [schemeData, setSchemeData] = useState([]);
  const [offersFetched, setOffersFetched] = useState(false);
  const [schemes, setSchemes] = useState([]);

  const [appliedSchemes, setAppliedSchemes] = useState([]);
  const [selectedSchemeId, setSelectedSchemeId] = useState(null);
  const [availableSchemes, setAvailableSchemes] = useState([]); // fetched via fetchSchemesForSCP
  const [tickerMessages, setTickerMessages] = useState([]);
  const [Status, setStatus] = useState('');

  const [showconfimationModal, setshowconfimationModal] = useState(false);

  const location = useLocation();

  const BYSCP = location.state?.BYSCP ?? null;


  let OrderNumberAudit;
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);

    sessionStorage.setItem('selectedScpId', selectedScpId);

  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);


  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Order Master (by SCP)", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  const customFilter = (option, searchText) => {
    // Ensure option.label and option.data.code are valid strings
    const label = option.label ? option.label.toLowerCase() : ''; // Safe label check
    const code = option.data?.code ? option.data.code.toLowerCase() : ''; // Safe code check using optional chaining

    const search = searchText ? searchText.toLowerCase() : ''; // Handle empty or undefined searchText

    return label.includes(search) || code.includes(search); // Perform filter comparison
  };

  const handleProductNameChange = (arg) => {
    let newValue = "";

    if (arg?.target) newValue = arg.target.value;
    else if (arg?.value) newValue = arg.value;
    else if (typeof arg === "string") newValue = arg;
    else return;

    console.log("handleProductNameChange ->", newValue);
    setSelectedProductName(newValue);

    const product = productNames.find(p => p.PL_ProductName === newValue);
    const qty = availableQuantity.find(p => p.PL_ProductName === newValue);

    if (product) {
      setproductcode(product.PL_ProductCode);
      setProductid(product.PL_ProductId);
    }

    setTotalPackSize(qty ? qty.totalPackSize : 0);

    document.getElementById("prdname").style.display = "none";
    logAction(`HandleProductName Change (): ${newValue}`);
  };


  const optionsproduct = productNames.map(group => ({
    label: group.PL_ProductName,
    value: group.PL_ProductName,
    code: group.PL_ProductCode // Adding code property to use in filter
  }));
  useEffect(() => {
    const fetchOrderTypes = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/OM/orderTypes`);
        setorderTypes(response.data);
      } catch (error) {
        console.error('Error fetching order types:', error);
      }
    };
    fetchOrderTypes();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1️⃣ Fetch order details
        const response = await fetch(`${config.API_URL}/OM/orderlist/toupdate/${ORDM_OrderNumber}/${UM_UserId}`);
        if (!response.ok) throw new Error("Failed to fetch order details");

        const data = await response.json();
        if (!data || data.length === 0) {
          setError("No data found for this order");
          return;
        }
        console.log("datadatadatadata    ", data)
        // 2️⃣ Extract key order details
        const fromSCP = data[0].FromSCPID;
        const toSCP = data[0].ToSCPID;
        const orderId = data[0].ORDM_OrderID;
        setorderID(orderId)
        const orderNumber = data[0].ORDM_OrderNumber;

        setSelectedfromScpName(data[0].FromSCPName);
        setFirstToScpName(data[0].ToSCPName);
        setselectedfromScpID(fromSCP);
        setselectedTOSCPID(toSCP);
        setOrderTableData(data);
        setStatus(data[0].Status);

        setoldtabledata(data.map(item => ({
          ProductName: item.ProductName,
          OrderQuantity: item.OrderQuantity
        })));
        setoId(orderNumber);

        // 3️⃣ Fetch order date and type
        const dateResponse = await axios.get(`${config.API_URL}/OM/orderdate/${orderNumber}`);
        if (dateResponse.data) {
          const orderDate = new Date(dateResponse.data.ORDM_OrderDate);
          setOrderDate(orderDate);
          setSelectedOrderType(dateResponse.data.ORDM_Type);
        }

        const available = await fetchSchemesForSCP(toSCP, fromSCP, data);

        // ✅ Then get and set the applied ones
        const schemeResponse = await fetch(`${config.API_URL}/OM/orderscheme/${orderNumber}`);

        recalculateTickerMessages(data, availableSchemes);
        if (schemeResponse.ok) {
          const schemeData = await schemeResponse.json();


          if (schemeData.success && schemeData.schemes?.length > 0) {
            setAppliedSchemes(schemeData.schemes);





            setSelectedSchemeId(schemeData?.schemes?.[0]?.SM_ID)
          }
        }

      } catch (error) {
        console.error("❌ Error fetching data:", error);
        setError("Something went wrong while loading the order");
      }
    };





    const fetchDropdownData = async () => {
      try {
        const productResponse = await fetch(`${config.API_URL}/OM/productnames/${UM_CompanyID}`);
        const productData = await productResponse.json();
        setProductNames(productData.PL_ProductName);
      } catch (error) {
        console.error("Error fetching product dropdown:", error);
      }
    };

    fetchData();
    fetchDropdownData();
  }, [ORDM_OrderNumber]);





  const handleApplyScheme = async (scheme, options = {}) => {
    const isAuto = options.isAuto || false;
    const orderData = options.orderData || orderTableData;


    setIsSaving(true);
    if (!isAuto && !scheme.isEligible) {
      console.warn(`⚠️ User is not eligible for "${scheme.SM_SchemeName}".`);
      setIsSaving(false);
      return;
    }



    // Replace another scheme if already selected
    if (selectedSchemeId && selectedSchemeId !== scheme.SM_ID) {
      const previousScheme = schemeData.find((s) => s.SM_ID === selectedSchemeId);

      toast.success(
        `Scheme : ${scheme.SM_SchemeName} applied successfully.`, { onClose: () => { setIsSaving(false); } }
      );
    } else if (!isAuto) {
      toast.success(`Scheme : ${scheme.SM_SchemeName} applied successfully.`, { onClose: () => { setIsSaving(false); } });
    }

    // Calculate multiplier
    const isCombination = scheme.SM_IsCombinationRequired === 1;

    const multipliers = scheme.requiredProducts.map((req, idx) => {


      const orderedProduct = orderData.find(
        (item) =>
          String(item.productid || item.ProductID || item.id) === String(req.SPM_ProductID) ||
          item.ProductName === req.ProductName
      );


      if (!orderedProduct) {
        console.warn(
          `❌ Ordered product not found for required product ID ${req.SPM_ProductID}`
        );
        setIsSaving(false);
        return 0;
      }

      const buyQty = Number(req.SPM_Quantity);
      if (!buyQty || buyQty <= 0) {
        console.warn(
          `⚠️ SPM_Quantity is zero or invalid for product ${req.SPM_ProductID}`
        );
        setIsSaving(false);
        return 0;
      }

      const orderedQty = Number(orderedProduct.OrderQuantity) || 0;

      const multiplier = Math.floor(orderedQty / buyQty);


      return multiplier;
    });



    let multiplier = 0;
    if (multipliers.length > 0) {
      multiplier = isCombination
        ? Math.min(...multipliers.filter((m) => m > 0)) || 0
        : Math.max(...multipliers) || 0;
    }



    // Prepare applied scheme object
    const appliedScheme = {
      discount: scheme.SM_Discount,
      giftArticle: null,
      freeProducts: [],
    };

    if (scheme.SM_Type === "3" || scheme.SM_Type === 3) {
      const baseGiftQty = Number(scheme.SM_Quantity || 1);
      const totalGiftQty = baseGiftQty * multiplier;

      appliedScheme.giftArticle = {
        name: scheme.SM_GiftArticle,
        quantity: totalGiftQty,

      };


    }

    if (scheme.freeProducts?.length > 0) {
      appliedScheme.freeProducts = scheme.freeProducts.map((fp) => ({
        freeProductId:
          fp.SFPM_ProductID ||
          fp.ProductID ||
          fp.SFPM_ProductCode ||
          fp.productid ||
          fp.freeProductId ||
          null,
        freeProductName:
          fp.PL_ProductName ||
          fp.ProductName ||
          fp.freeProductName ||
          "Unknown Product",
        freeQuantity: (Number(fp.SFPM_Quantity) || Number(fp.freeQuantity) || 0) * multiplier,
      }));



    }




    // 🧠 Merge free products into orderTableData
    setOrderTableData((prevData) => {
      let updatedData = [...prevData];
      console.groupCollapsed("%c🧮 handleApplyScheme → Merging free products into orderTableData", "color:#0ea5e9; font-weight:bold;");


      appliedScheme.freeProducts.forEach((fp) => {
        const existingIndex = updatedData.findIndex(
          (p) =>
            String(p.ProductID || p.productid) === String(fp.freeProductId) ||
            p.ProductName === fp.freeProductName
        );

        if (existingIndex !== -1) {
          console.groupCollapsed(
            `%c✅ Existing Product Found → ${updatedData[existingIndex].ProductName}`,
            "color:#22c55e; font-weight:bold;"
          );

          // ✅ Do NOT modify ordered quantity — only tag free qty separately
          updatedData[existingIndex] = {
            ...updatedData[existingIndex],
            isFree: true,
            freeQuantity: Number(fp.freeQuantity || 0),
          };


          console.groupEnd();
        } else {
          console.warn(
            `%c⚠️ Free-only product — adding new row for ${fp.freeProductName}`,
            "color:#f59e0b; font-weight:bold;"
          );

          updatedData.push({
            productid: fp.freeProductId,
            ProductName: fp.freeProductName,
            OrderQuantity: 0, // ❗ do not add free qty here
            isFree: true,
            freeQuantity: Number(fp.freeQuantity || 0),
          });
        }
      });


      console.groupEnd();
      return updatedData;
    });


    setAppliedSchemes((prev) => {
      const prevArr = Array.isArray(prev) ? prev : [];

      const newScheme = {
        ...scheme,
        SM_ID: scheme.SM_ID,
        SM_SchemeName: scheme.SM_SchemeName,
        SchemeName: scheme.SM_SchemeName,
        SchemeDescription: scheme.SM_SchemeDescription,
        SchemeType: scheme.SM_Type,
        SchemeValue:
          scheme.SM_Discount ||
          scheme.SM_Value ||
          appliedScheme.giftArticle?.quantity ||
          0, // 👈 Add this fallback
        GiftArticle:
          scheme.SM_GiftArticle || appliedScheme.giftArticle?.name || null,
        giftArticle: appliedScheme.giftArticle || null, // 👈 Keep the full object
        freeProducts: appliedScheme.freeProducts || [],
        discount: appliedScheme.discount || null,
        Benefit: scheme.Benefit || null,
        isApplied: true,
        DiscountType: scheme.SM_DiscountType,
      };

      const updated = [
        ...prevArr.filter((s) => String(s.SM_ID) !== String(scheme.SM_ID)),
        newScheme,
      ];


      return updated;
    });

    setSelectedSchemeId(scheme.SM_ID);




  };

  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTRN_OldValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName
    };

    try {
      const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
      // alert('Data inserted successfully');
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('Server responded with an error:', error.response.data);
      } else if (error.request) {
        // No response received from server
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  }
  useEffect(() => {

    // Fetch SCP details based on selectedScpId from the database
    fetch(`${config.API_URL}/OM/fetchScpDetails/${selectedScpId}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.SCPM_Name) {
          setSelectedfromScpName(data.SCPM_Name);
          setselectedfromScpLevelNo(data.SCPM_LevelNo);

        }
      })
      .catch(error => console.error('Error fetching SCP details:', error));
    fetch(`${config.API_URL}/OM/ProductList/${selectedScpId}`)
      .then(response => response.json())
      .then(data => {

        // setProductNames(data.PL_ProductName);
        // setFilteredProductNames(data.PL_ProductName);
        setavailableQuantity(data.PL_ProductName);
      })
      .catch(error => console.error('Error fetching product names:', error));
  }, [selectedScpId]);



  const handleAddOrder = () => {
    logAction(`Handle AddOrder (): Started`);

    // 🛑 Basic field validation
    if (selectedProductName.length === 0 || orderQuantity === "") {
      if (selectedProductName.length === 0) {
        document.getElementById("prdname").style.color = "red";
        document.getElementById("prdname").style.display = "inline";
      }
      if (orderQuantity === "") {
        document.getElementById("ordq").style.color = "red";
        document.getElementById("ordq").style.display = "inline";
      }
      return;
    }

    // ✅ Quantity validation
    const quantityRegex = /^(0|[1-9]\d*)$/;
    if (!quantityRegex.test(orderQuantity)) return;

    const sanitizedOrderQuantity = parseInt(orderQuantity, 10);

    // ✅ Clone order table
    let tempOrderTableData = [...orderTableData];
    const existingProductIndex = tempOrderTableData.findIndex(
      (item) => item.ProductName === selectedProductName
    );

    // 🧱 Update or insert new product
    if (existingProductIndex !== -1) {
      tempOrderTableData[existingProductIndex].OrderQuantity =
        (Number(tempOrderTableData[existingProductIndex].OrderQuantity) || 0) +
        (Number(sanitizedOrderQuantity) || 0);
    } else {
      tempOrderTableData.push({
        SCPM_Name: scpName,
        ProductName: selectedProductName,
        OrderQuantity: sanitizedOrderQuantity,
        OrderType: selectedOrderType,
        productcode: productcode,
        ProductID: productid || null,
      });
    }

    // ✅ Update table
    setOrderTableData(tempOrderTableData);

    // 🎯 Offer Eligibility & Ticker Message Handling
    if (offersFetched && availableSchemes.length > 0) {
      console.group("🧠 Checking eligible schemes after product add/update...");


      // Step 1: Find eligible schemes
      const eligibleSchemes = availableSchemes.filter((scheme) =>
        isSchemeEligible(scheme, tempOrderTableData)
      );

      // Step 2: Mark eligibility
      const enrichedSchemes = availableSchemes.map((scheme) => ({
        ...scheme,
        isEligible: eligibleSchemes.some(
          (el) => String(el.SM_ID) === String(scheme.SM_ID)
        ),
      }));

      setSchemeData(enrichedSchemes);

      // Step 3: 🟡 Build ticker messages
      const newTickerMessages = [];


      enrichedSchemes.forEach((scheme) => {
        if (!scheme.requiredProducts) return;

        const related = scheme.requiredProducts.some((req) =>
          tempOrderTableData.some(
            (item) =>
              String(item.productid) === String(req.SPM_ProductID) ||
              String(item.ProductName) === String(req.ProductName) ||
              String(item.ProductName) === String(req.PL_ProductName)
          )
        );
        if (!related) return;

        const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;
        let missingParts = [];

        // ✅ Get required product details
        const productDiffs = scheme.requiredProducts.map((req) => {
          const ordered = tempOrderTableData.find(
            (item) =>
              String(item.productid) === String(req.SPM_ProductID) ||
              String(item.ProductName) === String(req.ProductName) ||
              String(item.ProductName) === String(req.PL_ProductName)
          );

          const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
          const requiredQty = parseFloat(req?.SPM_Quantity || 0);
          const diff = requiredQty - orderedQty;
          const progressPercent = requiredQty > 0 ? (orderedQty / requiredQty) * 100 : 0;

          const prodName =
            ordered?.ProductName ||
            req.PL_ProductName ||
            req.Product_Name ||
            req.productname ||
            req.SPM_ProductName ||
            "this product";

          return { prodName, diff, progressPercent, orderedQty, requiredQty };
        });

        // 🧩 Combination scheme logic
        if (isCombination) {
          const partiallyProgressed = productDiffs.some(
            (p) => p.progressPercent >= 40
          );

          if (partiallyProgressed) {
            missingParts = productDiffs
              .filter((p) => p.diff > 0)
              .map((p) => {
                const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
              });
          }
        } else {
          // 🧮 Normal (OR) logic
          missingParts = productDiffs
            .filter((p) => p.progressPercent >= 40 && p.diff > 0)
            .map((p) => {
              const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
              return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
            });
        }

        if (missingParts.length > 0) {
          newTickerMessages.push(
            ` ${missingParts.join(" and ")} to avail ${scheme.SM_SchemeName} Offer`
          );
        }
      });

      // ✅ Deduplicate ticker messages
      const uniqueTickerMessages = [...new Set(newTickerMessages)];
      setTickerMessages(uniqueTickerMessages);


      console.groupEnd();

      // Step 4: Reapply or auto-apply schemes
      if (selectedSchemeId) {
        const stillEligible = eligibleSchemes.some(
          (scheme) => String(scheme.SM_ID) === String(selectedSchemeId)
        );

        if (!stillEligible) {
          setSelectedSchemeId(null);
          setAppliedSchemes([]);
        } else {
          const applied = availableSchemes.find(
            (s) => String(s.SM_ID) === String(selectedSchemeId)
          );
          if (applied) {

            handleApplyScheme(applied, { isAuto: true, orderData: tempOrderTableData });
          }
        }
      }

      if (!selectedSchemeId && eligibleSchemes.length === 1) {
        handleApplyScheme(eligibleSchemes[0], {
          isAuto: true,
          orderData: tempOrderTableData,
        });
        toast.success(`Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`);
      }

      if (eligibleSchemes.length > 1) {
        setSelectedSchemeId(null);
        setAppliedSchemes([]);
        setSchemeData(enrichedSchemes);
        toast.success("Multiple offers are applicable. Please choose the offer that benefits you the most.");
      }
    } else {
      console.warn("⚠️ No schemes fetched yet.");
    }

    // ✅ Reset input fields
    setEditedProductName("");
    setDropdownKeyprdname((prevKey) => prevKey + 1);
    setSelectedProductName("");
    setOrderQuantity("");
    logAction(`Handle AddOrder (): Ended`);
  };





  const handleordertypechange = (e) => {
    const newData = orderTableData.map(item => ({
      ...item,
      OrderType: e.target.value
    }));
    setOrderTableData(newData)
    setSelectedOrderType(e.target.value)

    setSelectedOrderType(e.target.value)
    document.getElementById('orderType').style.borderColor = '';
  }

  const handleRemove = (recordId, tableType) => {
    if (editingRowIndex == null) {
      let updatedOrderTableData = [...orderTableData];
      let updatedOrderData = [...orderData];

      if (tableType === 'orderData') {
        updatedOrderData = orderData.filter((_, index) => index !== recordId);
        setOrderData(updatedOrderData);
      } else if (tableType === 'orderTableData') {
        updatedOrderTableData = orderTableData.filter((_, index) => index !== recordId);
        setOrderTableData(updatedOrderTableData);
      }

      logAction(`HandleRemove(): Product Removed`);

      // 🎯 After removing, re-check scheme eligibility
      if (offersFetched && availableSchemes.length > 0) {

        const appliedSchemesArray = Object.values(availableSchemes || []);


        const eligibleSchemes = appliedSchemesArray.filter((scheme) =>
          isSchemeEligible(scheme, updatedOrderTableData)
        );

        const enrichedSchemes = appliedSchemesArray.map((scheme) => ({
          ...scheme,
          isEligible: eligibleSchemes.some(
            (el) => String(el.SM_ID) === String(scheme.SM_ID)
          ),
        }));

        setSchemeData(enrichedSchemes);

        // 🧠 Check if currently applied scheme is still valid
        if (selectedSchemeId) {
          const stillEligible = eligibleSchemes.some(
            (scheme) => String(scheme.SM_ID) === String(selectedSchemeId)
          );

          if (!stillEligible) {
            const removedScheme = schemes.find(
              (s) => s.SM_ID === selectedSchemeId
            );
            setSelectedSchemeId(null);
            setAppliedSchemes({});

          }
        }

        // 🟢 Auto-apply if only one eligible and none applied
        if (!selectedSchemeId && eligibleSchemes.length === 1) {
          handleApplyScheme(eligibleSchemes[0], {
            isAuto: true,
            orderData: updatedOrderTableData,
          });
          toast.success(
            `Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`
          );
        }

        // ⚠️ Multiple eligible schemes
        if (!selectedSchemeId && eligibleSchemes.length > 1) {
          setSelectedSchemeId(null);
          setAppliedSchemes({});
          setSchemeData(enrichedSchemes);


        }

        // ❌ No eligible schemes at all
        if (eligibleSchemes.length === 0 && !selectedSchemeId) {

        }
      }
    } else {
      // If editing, cancel editing state
      setEditingRowIndex(null);
      logAction(`Handle Edit (): Ended`);
    }
  };

  const handleOrderDateChange = (date) => {

    const formattedDate = formatDate(date);

    setOrderDate(formattedDate);
  };


  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


  const fetchSchemesForSCP = async (fromSCPID, toSCPID, data) => {
    try {
      if (!fromSCPID || !toSCPID) {
        toast.warning("Invalid SCP IDs. Cannot fetch schemes.");
        return [];
      }



      const response = await axios.post(`${config.API_URL}/OM/schemes`, {
        SM_FromSCPID: fromSCPID,
        SSM_SCPID: toSCPID,
      });

      const fetchedSchemes = response.data?.data || [];



      setAvailableSchemes(fetchedSchemes);
      setOffersFetched(true);
      recalculateTickerMessages(data, fetchedSchemes);

      return fetchedSchemes;
    } catch (error) {
      console.error("❌ Error fetching schemes:", error);

      return [];
    }
  };


  const targetPath = '/dashboard/ordermaster';


  const handleConfirmation = async () => {
    setIsSaving(true);
    if (orderTableData.length === 0) {

      if (!selectedProductName) {
        document.getElementById('prdname').style.display = 'inline';
        document.getElementById('prdname').style.color = 'red';
      }
      if (!orderQuantity) {
        document.getElementById('ordq').style.display = 'inline';
        document.getElementById('ordq').style.color = 'red';
      }

      if (!selectedProductName || !orderQuantity) {
        setIsSaving(false);
        return;
      }

      // Now check the table data
      if (orderTableData.length === 0) {
        toast.error("At least one product is required to save the order.", { onClose: () => setIsSaving(false) });
        return;
      }


      setIsSaving(false);
      return;
    } else {
      if (editingRowIndex == null) {
        setIsSaving(false);
        setshowconfimationModal(true);
      } else {
        document.getElementById('editingrowindex').style.display = 'inline';
        document.getElementById('editingrowindex').style.color = 'red';
        setIsSaving(false); // ✅ Stop loading
      }
    }
  }
  const handleUpdate = async () => {
    logAction(`Handle Update (): Started`)
    let appliedSchemeDetails = null;



    if (selectedSchemeId && Array.isArray(appliedSchemes)) {
      const appliedScheme = appliedSchemes.find(
        (s) => String(s.SM_ID) === String(selectedSchemeId)
      );
      const scheme = schemes.find(
        (s) => String(s.SM_ID) === String(selectedSchemeId)
      );

      if (appliedScheme) {
        const freeProducts = (appliedScheme.freeProducts || []).map((fp) => ({
          ProductID: fp.freeProductId || fp.ProductID || fp.productid,
          ProductName: fp.freeProductName || fp.ProductName,
          FreeQuantity: fp.freeQuantity || fp.FreeQuantity,
        }));

        appliedSchemeDetails = {
          SchemeID: appliedScheme?.SM_ID || null,
          SchemeName: appliedScheme?.SchemeName || "Unknown",
          SchemeType: appliedScheme?.SchemeType || "Unknown",
          Discount: appliedScheme.discount || null,
          GiftArticle: appliedScheme.giftArticle
            ? {
              name: appliedScheme.giftArticle.name,
              quantity: appliedScheme.giftArticle.quantity,
            }
            : null,
          FreeProducts: freeProducts,
        };


      }
    }

    setIsSaving(true); // 🔥 Start loading
    if (orderTableData.length === 0) {

      if (!selectedProductName) {
        document.getElementById('prdname').style.display = 'inline';
        document.getElementById('prdname').style.color = 'red';
      }
      if (!orderQuantity) {
        document.getElementById('ordq').style.display = 'inline';
        document.getElementById('ordq').style.color = 'red';
      }




      if (!selectedProductName || !orderQuantity) {
        return;
      }

      // Now check the table data
      if (orderTableData.length === 0) {
        toast.error("At least one product is required to save the order.");
        return;
      }

      setIsSaving(false);

      return;
    } else {

      if (editingRowIndex == null) {
        if (orderTableData.length == 0) {

          setIsSaving(false); // ✅ Stop loading
          return;
        }
        console.log("orderTableData : ", orderTableData)

        try {

          const response = await axios.get(`${config.API_URL}/OM/orders/${orderID}`);

          const olddata = response.data;

          try {
            const response = await axios.delete(`${config.API_URL}/OM/api/orders/${orderID}`);

            // let allPromises = orderTableData.map((orderTableData, index) => {
            //   return new Promise((resolve, reject) => {
            //     const date = new Date(olddata[0].ORDIT_CreatedTimestamp);
            //     const ORDIT_CreatedTimestamp = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
            //     const data = {
            //       order_id: orderID,
            //       product_id: orderTableData.ProductName,
            //       order_qty: orderTableData.OrderQuantity,
            //       pending_qty: orderTableData.OrderQuantity,
            //       created_by: UM_UserId,
            //       created_timestamp: ORDIT_CreatedTimestamp,
            //       modified_by: UM_UserId,
            //       modified_timestamp: formatDate(new Date()),
            //       company_grp_id: olddata[0].ORDIT_CompanyGrpId,
            //       company_id: olddata[0].ORDIT_CompanyID,
            //       schemeDetails: index === 0 ? appliedSchemeDetails : null,
            //     };

            //     // 🧩 Get scheme details if applied

            //     axios.post(`${config.API_URL}/OM/insert_order`, data)
            //       .then(response => {

            //         resolve();
            //       })
            //       .catch(error => {
            //         console.error('Error inserting data:', error.response ? error.response.data : error.message);
            //         reject(error);
            //       });
            //   });
            // });

            let allPromises = [];

            for (let index = 0; index < orderTableData.length; index++) {

              const item = orderTableData[index];

              const promise = new Promise((resolve, reject) => {

                const date = new Date(olddata[0].ORDIT_CreatedTimestamp);

                const ORDIT_CreatedTimestamp = `${date.getFullYear()}-${(date.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')}-${date.getDate()
                    .toString()
                    .padStart(2, '0')} ${date.getHours()
                      .toString()
                      .padStart(2, '0')}:${date.getMinutes()
                        .toString()
                        .padStart(2, '0')}:${date.getSeconds()
                          .toString()
                          .padStart(2, '0')}`;

                const data = {
                  order_id: orderID,
                  product_id: item.ProductName,
                  order_qty: item.OrderQuantity,
                  pending_qty: item.OrderQuantity,
                  created_by: UM_UserId,
                  created_timestamp: ORDIT_CreatedTimestamp,
                  modified_by: UM_UserId,
                  modified_timestamp: formatDate(new Date()),
                  company_grp_id: olddata[0].ORDIT_CompanyGrpId,
                  company_id: olddata[0].ORDIT_CompanyID,
                  schemeDetails: index === 0 ? appliedSchemeDetails : null,
                };

                axios.post(`${config.API_URL}/OM/insert_order`, data)
                  .then(response => {
                    resolve();
                  })
                  .catch(error => {
                    console.error(
                      'Error inserting data:',
                      error.response ? error.response.data : error.message
                    );
                    reject(error);
                  });
              });

              allPromises.push(promise);
            }

            Promise.all(allPromises)
              .then(() => {
                setIsSaveDisabled(true)
                logAction(`Handle Update (): Data Updated`)
                logAction(`Handle Update (): Ended`)
                logAction(`Redirecting (): Order Master by SCP `)
                let id;
                async function processAuditTrail() {
                  try {
                    const details = {
                      AUTR_Message: `${orderTableData[0].ORDM_OrderNumber} is Updated`,
                      AUTR_AuditType: 11
                    }
                    id = await (audittrailpost(details))
                    const oldProductMap = new Map();
                    const newProductMap = new Map();
                    oldtabledata.forEach(item => {
                      oldProductMap.set(item.ProductName, item.OrderQuantity);
                    });
                    orderTableData.forEach(item => {
                      newProductMap.set(item.ProductName, item.OrderQuantity);
                    });
                    const added = [];
                    const removed = [];
                    const quantityChanged = [];

                    newProductMap.forEach((quantity, name) => {
                      if (!oldProductMap.has(name)) {
                        const addedItem = {
                          productName: name,
                          quantity: quantity
                        };
                        const details = {
                          AUTRN_ID: id,
                          AUTRN_OldValue: "-",
                          AUTRN_NewValue: quantity,
                          AUTRN_ParamererName: name
                        };
                        audittransection(details)

                        added.push(addedItem);
                      } else if (oldProductMap.get(name) !== quantity) {
                        const oldQuantity = oldProductMap.get(name);
                        const newQuantity = quantity;

                        const oldObject = {
                          productName: name,
                          quantity: oldQuantity
                        };

                        const newObject = {
                          productName: name,
                          quantity: newQuantity
                        };


                        const details = {
                          AUTRN_ID: id,
                          AUTRN_OldValue: oldQuantity,
                          AUTRN_NewValue: newQuantity,
                          AUTRN_ParamererName: name
                        };
                        audittransection(details)
                        quantityChanged.push({
                          productName: name,
                          oldQuantity: oldQuantity,
                          newQuantity: newQuantity
                        });
                      }
                    });

                    oldProductMap.forEach((quantity, name) => {
                      if (!newProductMap.has(name)) {
                        removed.push({
                          productName: name,
                          quantity: quantity
                        });
                        const details = {
                          AUTRN_ID: id,
                          AUTRN_OldValue: quantity,
                          AUTRN_NewValue: "-",
                          AUTRN_ParamererName: name
                        };
                        audittransection(details)
                      }
                    });
                    setAddedProducts(added);
                    setRemovedProducts(removed);
                    setQuantityChangedProducts(quantityChanged);

                  } catch (error) {
                    console.error("Error:", error);
                  }
                }
                // Call the function with the details object
                processAuditTrail();
                toast.success(`Order : ${ORDM_OrderNumber} updated successfully.`, {
                  onClose: () => {
                    setIsSaving(false);
                    navigate(targetPath, { state: { BYSCP } });
                  },
                });

              })
              .catch(error => {
                console.error('Error:', error.message);
                sleep(200); setIsSaving(false); // ✅ Stop loading
              });
          } catch (error) {
            console.error('Error:', error.message);
            setIsSaving(false); // ✅ Stop loading
          }
        } catch (error) {
          console.error('Error fetching data from API: ', error);

          setIsSaving(false); // ✅ Stop loading
        }
      } else {
        document.getElementById('editingrowindex').style.display = 'inline';
        document.getElementById('editingrowindex').style.color = 'red';
        setIsSaving(false); // ✅ Stop loading
      }
    }
    logAction(`Handle Update (): Ended`)
    //await sleep(200); setIsSaving(false); // ✅ Stop loading
  };




  const handleChangeOrderQuantity = (e) => {

    const value = e.target.value;

    // 🧩 Allow only digits (no letters/symbols)
    // and disallow leading zero
    // ✅ Allows empty string (for deleting), or any number starting 1–9 up to 11 digits
    const regex = /^(?:[1-9][0-9]{0,10})?$/;

    if (regex.test(value)) {
      setOrderQuantity(value);

      // Handle empty
      if (value === "") {
        setisQuantityvalid(true);
        // document.getElementById("ordq").style.display = "inline";
        // document.getElementById("ordq").style.color = "red";
        return;
      }

      // Handle valid numeric input
      const numericValue = parseInt(value, 10);

      if (numericValue > 0) {
        setisQuantityvalid(false);
        seterrormsgOrderQuantity("");
        document.getElementById("ordq").style.display = "none";
      } else {
        setisQuantityvalid(true);
        seterrormsgOrderQuantity("Enter quantity greater than 0");
        document.getElementById("ordq").style.display = "inline";
        document.getElementById("ordq").style.color = "red";
      }
    } else {
      // ❌ Invalid input: starts with 0, non-numeric, or longer than 11 digits
      return; // Simply ignore invalid input
    }
  };



  const handleInputChange = (e) => {
    let value = e.target.value;

    // Allow only digits
    value = value.replace(/\D/g, "");

    // Block leading zeros
    value = value.replace(/^0+/, "");

    // Limit to 11 digits
    if (value.length > 11) {
      value = value.slice(0, 11);
    }

    setTempOrderQuantity(value);
  };

  const handleSaveClick = () => {
    logAction(`Handle Edit (): Started`);

    // 🛑 Validate input
    if (tempOrderQuantity === "" || tempOrderQuantity === null) {
      const input = document.getElementById("editingrowindexinput");
      if (input) {
        input.classList.add("input-error"); // Add red border
      }
      toast.error("Please enter quantity.");
      return;
    }

    const updatedOrderTableData = [...orderTableData];

    if (!isNaN(tempOrderQuantity) && tempOrderQuantity > 0) {
      // 🧾 Log changes
      logAction(
        `HandleEdit (): ${updatedOrderTableData[editingRowIndex].ProductName} - ${updatedOrderTableData[editingRowIndex].OrderQuantity}: Old Value`
      );
      logAction(
        `HandleEdit (): ${updatedOrderTableData[editingRowIndex].ProductName} - ${tempOrderQuantity}: New Value`
      );
      logAction(`HandleEdit (): Ended`);

      // ✅ Update table
      updatedOrderTableData[editingRowIndex].OrderQuantity = tempOrderQuantity;
      setOrderTableData(updatedOrderTableData);
      setEditingRowIndex(null);

      // 🧠 Scheme logic
      if (offersFetched && availableSchemes.length > 0) {
        console.group("🧠 Checking eligible schemes after edit...");


        // Step 1️⃣: Determine eligible schemes
        const eligibleSchemes = availableSchemes.filter((scheme) =>
          isSchemeEligible(scheme, updatedOrderTableData)
        );

        // Step 2️⃣: Enrich schemes with eligibility info
        const enrichedSchemes = availableSchemes.map((scheme) => ({
          ...scheme,
          isEligible: eligibleSchemes.some(
            (el) => String(el.SM_ID) === String(scheme.SM_ID)
          ),
        }));

        setSchemeData(enrichedSchemes);

        // Step 3️⃣: Ticker message logic ()
        const newTickerMessages = [];


        enrichedSchemes.forEach((scheme) => {
          if (!scheme.requiredProducts) return;

          // Check if this scheme relates to edited products
          const related = scheme.requiredProducts.some((req) =>
            updatedOrderTableData.some(
              (item) =>
                String(item.productid) === String(req.SPM_ProductID) ||
                String(item.ProductName) === String(req.ProductName) ||
                String(item.ProductName) === String(req.PL_ProductName)
            )
          );
          if (!related) return;

          const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;
          let missingParts = [];

          // ✅ Compute product differences
          const productDiffs = scheme.requiredProducts.map((req) => {
            const ordered = updatedOrderTableData.find(
              (item) =>
                String(item.productid) === String(req.SPM_ProductID) ||
                String(item.ProductName) === String(req.ProductName) ||
                String(item.ProductName) === String(req.PL_ProductName)
            );

            const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
            const requiredQty = parseFloat(req?.SPM_Quantity || 0);
            const diff = requiredQty - orderedQty;
            const progressPercent = requiredQty > 0 ? (orderedQty / requiredQty) * 100 : 0;

            const prodName =
              ordered?.ProductName ||
              req.PL_ProductName ||
              req.Product_Name ||
              req.productname ||
              req.SPM_ProductName ||
              "this product";

            return {
              productid: req.SPM_ProductID,
              prodName,
              diff,
              progressPercent,
              orderedQty,
              requiredQty,
            };
          });

          // 🧩 Combination scheme logic
          if (isCombination) {
            const partiallyProgressed = productDiffs.some(
              (p) => p.progressPercent >= 40
            );

            if (partiallyProgressed) {
              missingParts = productDiffs
                .filter((p) => p.diff > 0)
                .map((p) => {
                  const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                  return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
                });


            } else {

            }
          } else {
            // ✅ Normal (OR) scheme logic
            missingParts = productDiffs
              .filter((p) => p.progressPercent >= 40 && p.diff > 0)
              .map((p) => {
                const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
                return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
              });
          }

          //  Push ticker if applicable
          if (missingParts.length > 0) {
            newTickerMessages.push(
              ` ${missingParts.join(" and ")} to avail ${scheme.SM_SchemeName} Offer`
            );
          }
        });

        // ✅ De-duplicate and update state
        const uniqueTickerMessages = [...new Set(newTickerMessages)];
        setTickerMessages(uniqueTickerMessages);


        // Step 4️⃣: Handle existing or new scheme selection
        if (selectedSchemeId) {
          const stillEligible = eligibleSchemes.some(
            (scheme) => String(scheme.SM_ID) === String(selectedSchemeId)
          );

          if (!stillEligible) {
            setSelectedSchemeId(null);
            setAppliedSchemes([]);
          } else {
            const applied = availableSchemes.find(
              (s) => String(s.SM_ID) === String(selectedSchemeId)
            );
            if (applied) {

              handleApplyScheme(applied, {
                isAuto: true,
                orderData: updatedOrderTableData,
              });
            }
          }
        }

        // 🟢 Auto-apply single eligible scheme
        if (!selectedSchemeId && eligibleSchemes.length === 1) {
          handleApplyScheme(eligibleSchemes[0], {
            isAuto: true,
            orderData: updatedOrderTableData,
          });
          toast.success(
            `Scheme : ${eligibleSchemes[0].SM_SchemeName} applied successfully.`
          );
        }

        // ⚠️ Multiple eligible → open modal
        if ((!selectedSchemeId || selectedSchemeId) && eligibleSchemes.length > 1) {
          setSelectedSchemeId(null);
          setAppliedSchemes([]);
          setSchemeData(enrichedSchemes);
          toast.success("Multiple offers are applicable. Please choose the offer that benefits you the most.", { onClose: () => { setIsSaving(false); } });

        }

        console.groupEnd();
      } else {
        console.warn("⚠️ No schemes fetched yet.");
      }
    }
  };


  const handleEditClick = (index) => {
    logAction(`Handle Edit (): Started`)
    setEditingRowIndex(index);
    setTempOrderQuantity(orderTableData[index].OrderQuantity);
    setTimeout(() => {
      inputRef.current.focus();
    }, 0.000001);
  }

  const handlereset = () => {
    logAction(`Handle Reset (): All Products Removed`)
    setDropdownKeyprdname(prevKey => prevKey + 1); // Change key to force remount
    setSelectedProductName('');
    setOrderTableData([]);
    setAppliedSchemes({});
    setSelectedSchemeId(null);
    setEditingRowIndex(null);
    document.getElementById('prdname').style.display = 'none';
    document.getElementById('ordq').style.display = 'none';
  }
  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (UM_CompanyID === null || UM_CompanyID === "null" || UM_CompanyGrpID === null || UM_CompanyGrpID === "null" || selectedScpId === null || selectedScpId === "null") {

      const data = {
        AUTR_ScreenName: "Order Master by SCP",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };

      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);

        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    } else {

      const data = {
        AUTR_ScreenName: "Order Master by SCP",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp
      };

      try {
        const response = await axios.post(`${config.API_URL}/api/audittrail`, data);

        return response.data;
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };


  const getSortedSchemes = (schemeData, selectedSchemeId) => {
    // normalize selected id to string for safe comparison
    const selId = selectedSchemeId == null ? null : String(selectedSchemeId);

    // Helper: parse various date inputs into a local end-of-day Date
    const parseLocalEndDate = (dateInput) => {
      if (!dateInput) return null;

      // If already a Date
      if (dateInput instanceof Date && !isNaN(dateInput)) {
        const d = new Date(dateInput.getTime());
        d.setHours(23, 59, 59, 999);
        return d;
      }

      // If string like "DD-MM-YYYY" or "D-M-YYYY"
      if (typeof dateInput === "string") {
        const dashParts = dateInput.split("-");
        if (dashParts.length === 3) {
          // detect whether format is DD-MM-YYYY or YYYY-MM-DD (simple heuristic)
          const [p1, p2, p3] = dashParts.map((s) => s.trim());
          // if first part has length 4 -> assume YYYY-MM-DD
          if (p1.length === 4) {
            const y = Number(p1), m = Number(p2), d = Number(p3);
            if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d))
              return new Date(y, m - 1, d, 23, 59, 59, 999);
          } else {
            // assume DD-MM-YYYY
            const d = Number(p1), m = Number(p2), y = Number(p3);
            if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(d))
              return new Date(y, m - 1, d, 23, 59, 59, 999);
          }
        }

        // fallback: try Date constructor (ISO etc.)
        const parsed = new Date(dateInput);
        if (!isNaN(parsed)) {
          parsed.setHours(23, 59, 59, 999);
          return parsed;
        }

        return null;
      }

      // fallback: attempt to construct Date
      try {
        const d = new Date(dateInput);
        if (!isNaN(d)) {
          d.setHours(23, 59, 59, 999);
          return d;
        }
      } catch (e) {
        /* ignore */
      }
      return null;
    };

    // localToday at midnight (local)
    const now = new Date();
    const localToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    // Enrich schemes with parsed fields so sort and UI can reuse
    const enriched = (schemeData || []).map((s) => {
      const endDate = parseLocalEndDate(s.SM_EndDate);
      const diffDays = endDate ? Math.ceil((endDate - localToday) / (1000 * 60 * 60 * 24)) : null;
      const expiryLabel = diffDays === 1 ? "Ends today" : diffDays === 2 ? "Ends in 2 days" : "";
      const expiryColor = diffDays === 1 ? "#dc3545" : diffDays === 2 ? "#fd7e14" : "";
      return {
        ...s,
        __endDate: endDate,
        __diffDays: diffDays,
        __expiryLabel: expiryLabel,
        __expiryColor: expiryColor,
        __isApplied: selId != null && String(s.SM_ID) === selId,
        __isEligible: !!s.isEligible,
      };
    });

    // Priority function (lower number = higher precedence)
    const getPriority = (sch) => {
      const applied = sch.__isApplied;
      const eligible = sch.__isEligible;
      const diffDays = sch.__diffDays;

      const endsToday = diffDays === 1;
      const endsIn2 = diffDays === 2;

      // If applied: Applied first, then ends today, then ends in 2 days, then eligible
      if (applied) {
        if (applied) return 1;
        if (eligible) return 2;
        if (diffDays === 1) return 3;
        if (diffDays === 2) return 4;

        return 5;
      }

      // If NOT applied: ends today, ends in 2 days, eligible, others
      if (!applied) {
        if (eligible) return 6;
        if (endsToday) return 7;
        if (endsIn2) return 8;

        return 9;
      }

      return 10;
    };

    const sorted = enriched.sort((a, b) => {
      const pa = getPriority(a);
      const pb = getPriority(b);
      if (pa !== pb) return pa - pb;

      // tie-breakers: earlier expiry first, then eligible first, then alphabetic
      if ((a.__diffDays || Infinity) !== (b.__diffDays || Infinity)) {
        return (a.__diffDays || Infinity) - (b.__diffDays || Infinity);
      }
      if (a.__isEligible !== b.__isEligible) return a.__isEligible ? -1 : 1;

      return (a.SM_SchemeName || "").localeCompare(b.SM_SchemeName || "");
    });

    // Debug: show a neat table in console so you can verify
    console.table(
      sorted.map((s) => ({
        ID: s.SM_ID,
        Name: s.SM_SchemeName,
        Applied: s.__isApplied,
        Eligible: s.__isEligible,
        DiffDays: s.__diffDays,
        Expiry: s.__expiryLabel,
        Priority: getPriority(s),
      }))
    );
    console.groupEnd();

    return sorted;
  };

  // Usage:
  const sortedSchemes = getSortedSchemes(schemeData, selectedSchemeId);

  const isSchemeEligible = (scheme, orderTableData) => {
    console.group(`🧩 Checking eligibility for scheme: ${scheme?.SM_SchemeName} (ID: ${scheme?.SM_ID})`);

    if (!scheme?.requiredProducts || !Array.isArray(orderTableData)) {
      console.warn("❌ Invalid data — requiredProducts missing or orderTableData not array", {
        scheme,
        orderTableData,
      });
      console.groupEnd();
      return false;
    }

    const { SM_IsCombinationRequired } = scheme;


    if (SM_IsCombinationRequired === 1) {
      // ✅ Combination required (AND logic)
      const results = scheme.requiredProducts.map((sp, i) => {
        const ordered = orderTableData.find(
          (od) =>
            String(od.ProductID) === String(sp.SPM_ProductID) ||
            String(od.productcode) === String(sp.SPM_ProductID) ||
            od.ProductName?.toLowerCase() === sp.ProductName?.toLowerCase()
        );

        console.group(`➡️ Required Product #${i + 1}`);


        const isMet =
          ordered &&
          parseFloat(ordered.OrderQuantity) >= parseFloat(sp.SPM_Quantity);


        console.groupEnd();
        return isMet;
      });

      const finalResult = results.every(Boolean);

      console.groupEnd();
      return finalResult;
    } else {
      // ✅ Combination NOT required (OR logic)
      const results = scheme.requiredProducts.map((sp, i) => {
        const ordered = orderTableData.find(
          (od) =>
            String(od.ProductID) === String(sp.SPM_ProductID) ||
            String(od.productcode) === String(sp.SPM_ProductID) ||
            od.ProductName?.toLowerCase() === sp.ProductName?.toLowerCase()
        );

        console.group(`➡️ Required Product #${i + 1}`);


        const isMet =
          ordered &&
          parseFloat(ordered.OrderQuantity) >= parseFloat(sp.SPM_Quantity);


        console.groupEnd();
        return isMet;
      });

      const finalResult = results.some(Boolean);

      console.groupEnd();
      return finalResult;
    }
  };
  // ✅ Merge free products but keep OrderQuantity separate
  const mergedOrderData = React.useMemo(() => {
    console.groupCollapsed("%c🧩 mergedOrderData - Recalculation Started", "color:#0ea5e9; font-weight:bold;");

    // fresh clone — no mutations
    const combined = orderTableData.map(o => ({
      ...o,
      _hasFreeQty: false,
      _freeQty: 0,
      _isFreeOnly: false, // ✅ Mark normal ordered products
    }));





    // merge free products without touching existing order qty
    Object.values(appliedSchemes || {})
      .filter(s => Number(s.SchemeType) === 2 && s.freeProducts?.length > 0)
      .forEach((scheme, schemeIndex) => {
        console.groupCollapsed(
          `%c🎯 Scheme [${schemeIndex + 1}] - ${scheme.SM_SchemeName || "Unnamed"}`,
          "color:#16a34a; font-weight:bold;"
        );


        (scheme.freeProducts || []).forEach((fp, fpIndex) => {
          console.groupCollapsed(
            `%c🎁 Free Product [${fpIndex + 1}]`,
            "color:#10b981; font-weight:bold;"
          );


          const freeId = String(fp.freeProductId);
          const existingIndex = combined.findIndex(
            item =>
              String(item.productid) === freeId ||
              item.ProductName === fp.freeProductName
          );

          if (existingIndex !== -1) {

            combined[existingIndex] = {
              ...combined[existingIndex],
              _hasFreeQty: true,
              _freeQty: Number(fp.freeQuantity || 0),
            };


          } else {
            console.warn(
              `%c⚠️ Free-only product — adding new row for "${fp.freeProductName}"`,
              "color:#f59e0b; font-weight:bold;"
            );

            const newFreeRow = {
              productid: fp.freeProductId,
              ProductName: fp.freeProductName,
              productcode: fp.freeProductCode || 'N/A',
              OrderQuantity: 0,
              _hasFreeQty: true,
              _freeQty: Number(fp.freeQuantity || 0),
              _isFreeOnly: true,
            };



            combined.push(newFreeRow);
          }

          console.groupEnd(); // free product
        });

        console.groupEnd(); // scheme
      });



    console.groupEnd();

    return combined;
  }, [orderTableData, appliedSchemes]);

  const recalculateTickerMessages = (orderData, schemesList) => {

    if (!schemesList || schemesList.length === 0) return;

    const newTickerMessages = [];

    schemesList.forEach((scheme) => {
      if (!scheme.requiredProducts) return;

      // Check if scheme is related to this order
      const related = scheme.requiredProducts.some((req) =>
        orderData.some(
          (item) =>
            String(item.productid) === String(req.SPM_ProductID) ||
            String(item.ProductName) === String(req.ProductName) ||
            String(item.ProductName) === String(req.PL_ProductName)
        )
      );
      if (!related) return;

      const isCombination = parseInt(scheme.SM_IsCombinationRequired) === 1;
      let missingParts = [];

      const productDiffs = scheme.requiredProducts.map((req) => {
        const ordered = orderData.find(
          (item) =>
            String(item.productid) === String(req.SPM_ProductID) ||
            String(item.ProductName) === String(req.ProductName) ||
            String(item.ProductName) === String(req.PL_ProductName)
        );

        const orderedQty = parseFloat(ordered?.OrderQuantity || 0);
        const requiredQty = parseFloat(req?.SPM_Quantity || 0);
        const diff = requiredQty - orderedQty;
        const progressPercent = requiredQty > 0 ? (orderedQty / requiredQty) * 100 : 0;

        const prodName =
          ordered?.ProductName ||
          req.PL_ProductName ||
          req.Product_Name ||
          req.productname ||
          req.SPM_ProductName ||
          "this product";

        return { prodName, diff, progressPercent, orderedQty, requiredQty };
      });

      if (isCombination) {
        const partiallyProgressed = productDiffs.some(
          (p) => p.progressPercent >= 40
        );
        if (partiallyProgressed) {
          missingParts = productDiffs
            .filter((p) => p.diff > 0)
            .map((p) => {
              const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
              return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
            });
        }
      } else {
        missingParts = productDiffs
          .filter((p) => (p.progressPercent || 0) >= 40 && p.diff > 0)
          .map((p) => {
            const qtyLabel = p.diff === 1 ? "quantity" : "quantities";
            return `Add ${p.diff} more ${qtyLabel} of ${p.prodName}`;
          });
      }

      if (missingParts.length > 0) {
        newTickerMessages.push(
          ` ${missingParts.join(" and ")} to avail ${scheme.SM_SchemeName} Offer`
        );
      }
    });

    const uniqueMessages = [...new Set(newTickerMessages)];
    setTickerMessages(uniqueMessages);
  };

  const tickerRef = useRef(null);
  useEffect(() => {
    if (!tickerRef.current) return;

    const ticker = tickerRef.current;
    const width = ticker.scrollWidth / 2; // because duplicated

    const speed = 100; // pixels per second (you can change this)
    const duration = width / speed;

    ticker.style.animation = `scrollTrain ${duration}s linear infinite`;
  }, [tickerMessages]);

  return (
    <>
      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      {isSaving && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height
          zIndex: 9999 // Sit on top of the other elements
        }} />
      )}
      <div className='main_container'>

        <div className="orderHeader d-flex align-items-center justify-content-between">
          <h4 className="formHeading" >
            {parseInt(BYSCP) === 0
              ? "Order Master (by Sales Officer)"
              : "Order Master (by SCP)"}
          </h4>
          <div className="d-flex align-items-center">


            {(offersFetched && (availableSchemes.length > 0 || appliedSchemes.length > 0)) && (
              <button
                type="button"
                disabled={editingRowIndex !== null}
                className={`orderHeader_btn me-2 d-flex align-items-center justify-content-center position-relative
              `}
                style={{
                  fontWeight: 600,
                  position: "relative",
                  padding: "10px 24px",
                  borderRadius: "8px",
                  transition: "none", // stop color transition
                  overflow: "visible", // allow badge to overflow outside button
                }}
                onClick={() => {


                  let mergedSchemes = [];


                  if (availableSchemes.length > 0) {
                    mergedSchemes = [...availableSchemes];
                  } else if (schemes.length > 0) {
                    mergedSchemes = [...schemes];
                  }


                  // 2️⃣ Include applied schemes from backend (if any)
                  if (appliedSchemes && Array.isArray(appliedSchemes)) {
                    appliedSchemes.forEach((applied) => {
                      const exists = mergedSchemes.some(
                        (s) => String(s.SM_ID) === String(applied.SM_ID)
                      );
                      if (!exists) {
                        mergedSchemes.push({
                          ...applied,
                          isApplied: true,
                          isEligible: true, // applied ones are always valid
                        });
                      } else {
                        mergedSchemes = mergedSchemes.map((s) =>
                          String(s.SM_ID) === String(applied.SM_ID)
                            ? { ...s, isApplied: true, isEligible: true }
                            : s
                        );
                      }
                    });
                  }

                  // 🧠 3️⃣ Recalculate eligibility based on current orderTableData
                  const enrichedSchemes = mergedSchemes.map((scheme) => {
                    const eligible = isSchemeEligible(scheme, orderTableData);

                    return { ...scheme, isEligible: eligible };
                  });

                  // 4️⃣ Sort applied first, then eligible, then others
                  enrichedSchemes.sort((a, b) => {
                    if (a.isApplied && !b.isApplied) return -1;
                    if (!a.isApplied && b.isApplied) return 1;
                    if (a.isEligible && !b.isEligible) return -1;
                    if (!a.isEligible && b.isEligible) return 1;
                    return 0;
                  });


                  // 5️⃣ Update modal data and open
                  setSchemeData(enrichedSchemes);
                  setIsSchemeModalOpen(true);

                  console.groupEnd();
                }}

              >
                APPLY OFFERS


                {(() => {
                  let allSchemes = [];

                  if (availableSchemes?.length > 0) {
                    allSchemes = [...availableSchemes];
                  } else if (schemes?.length > 0) {
                    allSchemes = [...schemes];
                  }

                  // Include appliedSchemes if any
                  if (appliedSchemes?.length > 0) {
                    appliedSchemes.forEach((applied) => {
                      const exists = allSchemes.some(s => String(s.SM_ID) === String(applied.SM_ID));
                      if (!exists) {
                        allSchemes.push({ ...applied, isApplied: true, isEligible: true });
                      }
                    });
                  }

                  // Recalculate eligibility on the fly
                  const eligibleCount = allSchemes.filter(s => isSchemeEligible(s, orderTableData)).length;

                  if (eligibleCount > 0)
                    return (
                      <span
                        className="badge bg-danger offer-badge position-absolute"
                        style={{
                          top: "-8px",
                          right: "-8px",
                          fontSize: "0.7rem",
                          padding: "4px 7px",
                          borderRadius: "50%",
                          animation: "pulseBadge 1.5s infinite",
                          transformOrigin: "center",
                          pointerEvents: "none",
                        }}
                      >
                        {eligibleCount}
                      </span>
                    );
                })()}

              </button>
            )}

            <style jsx>{`
  @keyframes pulseBadge {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.25);
      opacity: 0.85;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`}</style>
          </div>



        </div>

        {isTemplatePopupOpen && (
          <></>
        )}
        <div className="row mb-4">
          <div className="col-md-3">
            {/* <div className="form-group"> */}
            <label htmlFor="orderNumber">Order Number</label>
            <input type="text" id="orderNumber" value={ORDM_OrderNumber} readOnly className="form-input" style={{
              backgroundColor: '#f2f2f2',
              color: '#6c757d',
            }} />
            {/* </div> */}
          </div>
          <div className="col-md-3">
            <label htmlFor="orderDate">Order Date</label>
            <div className="select-container_list" style={{
              backgroundColor: '#f2f2f2',
              color: '#6c757d',
              cursor: 'not-allowed'
            }}
            >
              <DatePicker
                id="orderDate"
                selected={new Date(orderDate)}
                onChange={handleOrderDateChange}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                className="routing_select-box"
                // disabled={isDateDisabled || editingRowIndex !== null}
                readOnly
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                open={isOpen}
                onClickOutside={() => setIsOpen(false)}
                customInput={
                  <input
                    style={{
                      backgroundColor: "#f2f2f2",
                      color: "#6c757d"

                    }}
                  />
                }
              />
              <div
                className="icon-container_list myList"
                onClick={(e) => {
                  if (editingRowIndex !== null) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  setIsOpen((prev) => !prev); // Toggle open/close
                }}
                style={{
                  cursor: 'not-allowed',
                }}
              >
                <i>
                  <IoCalendarOutline />
                </i>
              </div>
            </div>
          </div>
          {/* <div className='col-md-1'>
            <Link disabled> <img title='Calendar' src={Icon7} alt="Calendar" className="bi bi-calendar-icon calendar" style={{ width: '30px', height: '30px', cursor: 'pointer' }} disabled /></Link>
          </div> */}
          <div className="col-md-3">
            <label htmlFor="orderType" className="">Order Type</label>
            <div className="select-container_list">

              <ReactSelectDropDown
                name="orderType"
                options={orderTypes}
                value={selectedOrderType}                          // Only the value
                onChange={handleordertypechange} // Full object returned
                placeholder="--Select--"
                idKey="EnumVal"                                    // must match your mapping
                displayKey="Description"
                disabled={true}               // disable support ✔
                onMenuOpen={() => handleSelectOpen("orderType")}
                onMenuClose={handleSelectClose}
                className="routing_select-box"
              />


            </div>
          </div>
          <div className="col-md-3">
            {/* <div className="form-group"> */}
            <label htmlFor="orderType" className="">Order Status</label>


            <input value={Status} disabled style={{
              backgroundColor: '#f2f2f2',
              color: '#6c757d',
            }} />
            {/* </div> */}
          </div>
          {/* </div> */}
        </div>

        {offersFetched && orderTableData.length > 0 && tickerMessages.length > 0 && (
          <div className="offer-ticker-wrapper">
            <div
              className="offer-ticker"
              ref={tickerRef}
            >
              <div className="ticker-content flex-1">
                {tickerMessages.map((msg, idx) => (
                  <span key={`msg1-${idx}`} className="ticker-item">
                    {msg}
                  </span>
                ))}
                <span
                  aria-hidden="true"
                  style={{ display: "inline-block", width: "40vw" }}
                />
              </div>

              <div className="ticker-content flex-1">
                {tickerMessages.map((msg, idx) => (
                  <span key={`msg2-${idx}`} className="ticker-item">
                    {msg}
                  </span>
                ))}
                <span
                  aria-hidden="true"
                  style={{ display: "inline-block", width: "40vw" }}
                />
              </div>
            </div>
          </div>
        )}



        {selectedSchemeId && (() => {
          let reward = null;

          if (Array.isArray(appliedSchemes)) {
            reward = appliedSchemes.find(s => String(s.SM_ID) === String(selectedSchemeId));
          } else if (appliedSchemes && appliedSchemes[selectedSchemeId]) {
            reward = appliedSchemes[selectedSchemeId];
          }

          if (!reward) return null;

          const schemeInfo = schemes.find(s => String(s.SM_ID) === String(selectedSchemeId)) || {};
          const combinedReward = { ...schemeInfo, ...reward };

          return (
            <div
              className="border-0 p-4 mb-3 rounded-xl shadow-sm reward-card animate-fadeIn"
              style={{
                borderRadius: "12px",
                background: "linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)",
                position: "relative",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(16, 185, 129, 0.08)",
              }}
            >
              <div className="absolute inset-0 opacity-30 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(circle at 20% 80%, rgba(34, 197, 94, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.25) 0%, transparent 50%)",
                  animation: "pulse 6s ease-in-out infinite",
                }}
              />

              <div className="flex items-center gap-2 mb-3">
                <h6 className="fw-bold text-success mb-2">🎉 Scheme Benefits</h6>
              </div>
              <div

                className="group p-3 rounded-lg bg-white/70 backdrop-blur-sm border border-emerald-100 transition-all duration-200 hover:bg-white hover:shadow-md"
                style={{
                  borderBottom: "1px dashed #a7f3d0",
                }}
              >
                {/* 🌟 Scheme Header */}
                <div className="font-semibold text-emerald-800 text-base flex items-center gap-1.5">
                  <span className="text-emerald-600">✦</span>{" "}
                  {combinedReward.SchemeName || combinedReward.SM_SchemeName || "Scheme Details"}
                </div>

                {combinedReward.SchemeDescription && (
                  <p className="text-sm text-gray-600 mt-1 leading-relaxed">
                    {combinedReward.SchemeDescription}
                  </p>
                )}

                {/* 💰 Discount */}
                {Number(combinedReward.SchemeType) === 1 && combinedReward.SchemeValue && (
                  <div className="d-flex align-items-center mb-1">
                    <span className="me-2">💰</span>
                    <span>
                      You will receive a{' '}
                      <strong>
                        {combinedReward.SchemeValue}
                        {combinedReward.DiscountType === 1
                          ? ' %'
                          : combinedReward.DiscountType === 2
                            ? ' Rs.'
                            : ''}
                      </strong>{' '}
                      discount
                    </span>

                  </div>
                )}

                {/* 🎁 Gift Article */}
                {Number(combinedReward.SchemeType) === 3 && combinedReward.GiftArticle && (
                  <div className="d-flex align-items-center mb-1">
                    <span className="me-2">🎁</span>
                    <span>
                      You will receive{" "}
                      <strong>
                        {Number(combinedReward.giftArticle?.quantity || 0)}
                      </strong>{" "}
                      quantity of <strong>{combinedReward.GiftArticle}</strong> as a gift article
                    </span>
                  </div>
                )}


                {Number(combinedReward.SchemeType) === 2 &&
                  combinedReward.freeProducts?.length > 0 && (
                    <div>
                      {combinedReward.freeProducts.map((fp, idx) => (
                        <div key={idx} className="d-flex align-items-center mb-1">
                          <span className="me-2">🆓</span>
                          <span>
                            You will receive{" "}
                            <strong>
                              {Number(fp.freeQuantity || 0)} quantity of {fp.freeProductName} {fp.ProductID}
                            </strong>{" "}
                            as free
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            </div>
          );
        })()}



        <div className="border p-3">
          {/* <div class="text-left"> */}

          {/* </div> */}



          <div className="row">
            <div className="col">
              {/* <div className="form-group "> */}
              <label htmlFor="scpName" className="label1">From</label>
              <div className='select-container'>
                <input value={selectedfromScpName} className="form-input" readOnly style={{
                  backgroundColor: '#f2f2f2',
                  color: '#6c757d',
                }} />
                <div className="icon-container">
                  <IoCaretDownOutline />
                </div>
              </div>

              {/* </div> */}
            </div>
            <div className="col">
              {/* <div className="form-group mt-5"> */}
              <label htmlFor="orderNumber" className="label1">To</label>
              <div className='select-container'>
                <input value={firstToScpName} className="form-input" readOnly style={{
                  backgroundColor: '#f2f2f2',
                  color: '#6c757d',
                }} />
                <div className="icon-container">
                  <IoCaretDownOutline />
                </div>
              </div>
              {/* </div> */}
            </div>
            <div className="col">
              <label htmlFor="editedProductName" className="label1">Product Name<strong style={{ display: 'none' }} id="prdname">*</strong></label>
              <div className="select-container_list">

                <ReactSelectDropDown
                  key={dropdownKeyprdname}
                  name="productName"
                  options={optionsproduct}
                  value={selectedProductName}                          // Only the value
                  onChange={handleProductNameChange} // Full object returned
                  placeholder="--Select--"
                  idKey="value"                                    // must match your mapping
                  displayKey="label"
                  disabled={editingRowIndex !== null}               // disable support ✔
                  onMenuOpen={() => handleSelectOpen("productName")}
                  onMenuClose={handleSelectClose}
                  className="routing_select-box"
                  enableScrollEffect={orderTableData.length > 0 ? false : true}
                />


              </div>
            </div>
            <div className="col">
              {/* <div className="form-group mt-5"> */}
              <label htmlFor="orderQuantity" className="label1">Order Quantity<strong style={{ display: 'none' }} id="ordq">*</strong></label>
              <div className="form-group d-flex align-items-center">
                <input
                  type="text"
                  id="orderQuantity"
                  value={orderQuantity}
                  autoComplete="off"
                  onChange={handleChangeOrderQuantity}
                  className="form-input"
                  disabled={editingRowIndex !== null}
                />{isQuantityvalid && <><label style={{ color: 'red' }}>{errormsgOrderQuantity}</label></>}
              </div>
              {/* </div> */}
            </div>
            <div className="col">
              {/* <div className="form-group mt-5"> */}
              <label htmlFor="availableQuantity" className="label1">Available Quantity</label>
              <input
                className="form-input"
                readOnly
                style={{
                  backgroundColor: '#f2f2f2',
                  color: '#6c757d',
                  cursor: 'not-allowed'
                }}
                value={totalPackSize}
              />

            </div>
          </div>
          <div className='p-3'>
            <div className="col-auto d-flex justify-content-end">
              <button className="order_addbtn1" onClick={handleAddOrder} disabled={editingRowIndex !== null}>
                ADD
              </button>
              {/* <strong style={{ display: 'none' }} id="addfornext">*</strong> */}
            </div>
          </div>
        </div>


        {isSchemeModalOpen && (
          <div className="popup_overlay">
            <div className="popup">

              <div>
                <Link onClick={() => setIsSchemeModalOpen(false)} state={{ BYSCP }}><Image src={x} alt="x" className="x" /></Link>
              </div>

              <h3 className="modal-title">
                Available Schemes
              </h3>

              <div>
                <table className="tableClass">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Scheme Name</th>
                      <th>Description</th>
                      <th>Apply</th>
                    </tr>
                  </thead>
                  <tbody>


                    {sortedSchemes.map((scheme, index) => {

                      const isSelected = String(selectedSchemeId) === String(scheme.SM_ID);
                      let endDate;
                      // Parse DD-MM-YYYY manually to avoid UTC issues


                      if (scheme.SM_EndDate instanceof Date) {
                        endDate = new Date(scheme.SM_EndDate.getTime());
                      } else {
                        endDate = new Date(scheme.SM_EndDate);
                      }


                      endDate.setHours(23, 59, 59, 999);


                      const today = new Date();
                      const localToday = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // ✅ local midnight

                      const diffTime = endDate - localToday;
                      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));


                      let expiryLabel = "";
                      let expiryColor = "";

                      if (diffDays === 1) {
                        expiryLabel = "Ends today";
                        expiryColor = "#dc3545";
                      } else if (diffDays === 2) {
                        expiryLabel = "Ends in 2 days";
                        expiryColor = "#fd7e14";
                      }

                      return (
                        <tr
                          key={index}
                          style={{
                            backgroundColor: isSelected ? "#a7f7d2ff" : "transparent",
                            opacity: scheme.isSchemeApplied === 0 ? 0.6 : 1,
                            transition: "background-color 0.25s ease",
                          }}
                        >
                          <td>{index + 1}</td>

                          <td>
                            <div>
                              <span
                                style={{
                                  fontWeight: isSelected ? "600" : "500",
                                }}
                              >
                                {scheme.SM_SchemeName}
                              </span>

                              {/* 🏷️ Expiry badge */}
                              {expiryLabel && (
                                <span
                                  style={{
                                    backgroundColor: expiryColor,
                                    color: "#fff",
                                    borderRadius: "4px",
                                    padding: "2px 8px",
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    whiteSpace: "nowrap",
                                    marginLeft: "8px",
                                  }}
                                >
                                  {expiryLabel}
                                </span>
                              )}
                            </div>
                          </td>

                          <td style={{ padding: "12px 8px", border: "1px solid #ddd" }}>
                            {scheme.SM_SchemeDescription}
                          </td>

                          <td
                            style={{
                              padding: "12px 8px",
                              border: "1px solid #ddd",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <button
                              disabled={!scheme.isEligible} // ✅ completely disable if not eligible
                              onClick={(e) => {
                                // 💧 Ripple animation
                                const button = e.currentTarget;
                                const rect = button.getBoundingClientRect();
                                const x = e.clientX - rect.left;
                                const y = e.clientY - rect.top;
                                const ripple = document.createElement("span");
                                const size = Math.max(rect.width, rect.height);
                                ripple.style.width = ripple.style.height = `${size}px`;
                                ripple.style.left = `${x - size / 2}px`;
                                ripple.style.top = `${y - size / 2}px`;
                                ripple.style.position = "absolute";
                                ripple.style.borderRadius = "50%";
                                ripple.style.background = "rgba(255, 255, 255, 0.6)";
                                ripple.style.transform = "scale(0)";
                                ripple.style.animation = "ripple 0.6s ease-out";
                                ripple.style.pointerEvents = "none";
                                button.appendChild(ripple);
                                setTimeout(() => ripple.remove(), 600);

                                // tap feedback
                                button.style.transform = "scale(0.92)";
                                setTimeout(() => (button.style.transform = ""), 150);

                                // 🚫 Not eligible
                                if (!scheme.isEligible && !scheme.isApplied) {

                                  return;
                                }

                                // 🧩 Toggle logic
                                if (selectedSchemeId === scheme.SM_ID) {
                                  // 🔹 Same scheme clicked again → unapply

                                  setSelectedSchemeId(null);
                                  setAppliedSchemes([]);

                                } else {
                                  // 🔹 New scheme clicked → replace any existing one
                                  if (selectedSchemeId) {
                                    const previous = schemeData.find(s => s.SM_ID === selectedSchemeId);


                                  }
                                  setSelectedSchemeId(scheme.SM_ID);
                                  setAppliedSchemes([scheme]); // store as single active scheme
                                  handleApplyScheme(scheme);

                                }
                              }}

                              style={{
                                width: "42px",
                                height: "42px",
                                borderRadius: "50%",
                                backgroundColor: isSelected ? "#10b981" : scheme.isEligible ? "#fff" : "#f3f4f6",
                                border: isSelected
                                  ? "2px solid #059669"        // ✅ green when selected
                                  : scheme.isEligible
                                    ? "2.5px solid #1d4b73"        // ✅ darker blue border when eligible
                                    : "2px solid #9c9898ff",     // gray when not eligible
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: isSelected || scheme.isEligible ? "pointer" : "not-allowed",
                                opacity: isSelected || scheme.isEligible ? 1 : 0.6,
                                transition: "all 0.15s ease, transform 0.15s ease",
                                margin: "0 auto",
                                position: "relative",
                                overflow: "hidden",
                                outline: "none",
                              }}
                              title={
                                scheme.isApplied
                                  ? "Scheme already applied to this order"
                                  : isSelected
                                    ? "Click to remove this scheme"
                                    : !scheme.isEligible
                                      ? "You are not eligible for this scheme"
                                      : "Click to apply this scheme"
                              }
                            >
                              {isSelected ? (
                                <span style={{ color: "#fff", fontSize: "18px", fontWeight: "bold" }}>✓</span>
                              ) : (
                                <Check
                                  size={26}
                                  color={scheme.isEligible ? "#295a80" : "#b0b0b0"}
                                  strokeWidth={scheme.isEligible ? 5 : 3}
                                />
                              )}
                            </button>

                            <style jsx>{`
          @keyframes ripple {
            to {
              transform: scale(2);
              opacity: 0;
            }
          }
        `}</style>
                          </td>
                        </tr>
                      );
                    })}

                  </tbody>
                </table>
              </div>

              <div
                style={{
                  marginTop: "24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >

                {/* <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    style={{
                      backgroundColor: "#10b981",
                      border: "none",
                      padding: "10px 20px",
                      borderRadius: "6px",
                      color: "#fff",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                    onClick={() => {
                      if (!selectedSchemeId) {
                     
                        return;
                      }
                      setIsSchemeModalOpen(false);
                    
                    }}
                  >
                    SAVE & APPLY
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        )}





        <div className="table_container mt-4">
          <table className="order_tableClass">
            {mergedOrderData.length > 0 && (
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Product Name</th>
                  <th>Product Code</th>
                  <th>Order Quantity</th>
                  <th>Action</th>
                </tr>
              </thead>
            )}

            <tbody>
              {mergedOrderData.length > 0 ? (
                mergedOrderData.map((order, index) => (
                  <tr
                    key={`orderTableData-${index}`}
                    style={{
                      backgroundColor: order._isFreeOnly ? '#f5fff5' : 'transparent', // ✅ green for free-only
                    }}
                  >
                    <td>{index + 1}</td>
                    <td>{order.ProductName}</td>
                    <td>
                      {productNames.find(
                        (option) => option.PL_ProductName === order.ProductName
                      )?.PL_ProductCode || 'N/A'}
                    </td>

                    {editingRowIndex === index && !order._isFreeOnly ? (
                      <td>
                        <input
                          type="number"
                          autoComplete="off"
                          className="editingrowindex"
                          value={tempOrderQuantity}
                          onChange={handleInputChange}
                          ref={inputRef}
                          onWheel={(e) => e.target.blur()} // Disable scroll to change number
                          onKeyDown={(e) => {
                            // prevent typing e, +, -, . for cleaner number-only input
                            if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                          }}
                        />
                      </td>
                    ) : (
                      <td className="orderquantitytable">
                        {order._isFreeOnly || Number(order.OrderQuantity) === 0 ? (
                          <span style={{ color: 'green', fontWeight: '500' }}>
                            {order._freeQty} (Free)
                          </span>
                        ) : (
                          <>
                            {order.OrderQuantity}
                            {order._hasFreeQty && order._freeQty > 0 && (
                              <>
                                {' '}
                                +{' '}
                                <span style={{ color: 'green', fontWeight: '500' }}>
                                  {order._freeQty} (Free)
                                </span>
                              </>
                            )}
                          </>
                        )}
                      </td>
                    )}

                    <td style={{ textAlign: 'center' }}>
                      {(order._isFreeOnly || Number(order.OrderQuantity) === 0) ? (
                        <span style={{ color: '#9ca3af', fontWeight: '600' }}>–</span>
                      ) : (
                        <>
                          {editingRowIndex === index ? (
                            <>
                              <img
                                className="editicon"
                                title="Save"
                                src={accept}
                                alt="save"
                                onClick={handleSaveClick}
                                style={{ height: "16px", width: "16px" }}
                                disabled={issavedisabled}
                              />
                              <strong style={{ display: "none" }} id="editingrowindex">
                                *
                              </strong>
                            </>
                          ) : (
                            <img
                              className="editicon"
                              src={Icon3}
                              title="Edit"
                              alt="edit"
                              onClick={() => handleEditClick(index)}
                              disabled={issavedisabled}
                            />
                          )}
                          <img
                            className={`bi bi-x-lg form-button-remove ${issavedisabled ? 'disabled' : ''}`}
                            src={Icon5}
                            title="Remove"
                            alt="Remove"
                            onClick={!issavedisabled ? () => handleRemove(index, 'orderTableData') : null}
                          />
                        </>
                      )}
                    </td>

                  </tr>
                ))
              ) : (
                // Optional empty-state message 👇
                <tr>

                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div >

      {/* ================== MODALS ================== */}
      {showconfimationModal && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to edit the Order : {ORDM_OrderNumber} ?</h4>
            <div className="popup_btn_container">
              <button
                className="yes_btn"
                onClick={() => {
                  setshowconfimationModal(false);
                  handleUpdate();
                }}
              >
                YES
              </button>

              <button
                className="no_btn"
                onClick={() => { setshowconfimationModal(false); setIsSaving(false); }}
              >
                NO
              </button>

            </div>
          </div>
        </div>
      )}

      <div className="button-container" >
        <button
          className=" save_btn"
          onClick={() => handleConfirmation()}

        >
          SAVE
        </button>

        <button className="reset_btn" onClick={handlereset} disabled={issavedisabled || editingRowIndex !== null}>RESET</button>
        <Link to={`/dashboard/orderlist`}
          state={{ BYSCP }}
          className="list_btn"
          onClick={(e) => {
            if (editingRowIndex !== null) {
              e.preventDefault(); // Stop navigation
            } else {
              logAction(`Redirecting (): LIST PAGE`);
            }
          }}
          style={{
            pointerEvents: editingRowIndex !== null ? 'none' : 'auto',
            cursor: editingRowIndex !== null ? 'not-allowed' : 'pointer'
          }} >
          LIST
        </Link>
      </div>
    </>
  );
};
export default EditOrderList;